import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

const EmptyNotifications = ({ isLoading }: { isLoading?: boolean }) => (
  <Box sx={{ minHeight: '116px' }}>
    {!isLoading && (
      <Box p={3}>
        <Typography variant="body2" mb={2}>
          You have no new notifications.
        </Typography>
      </Box>
    )}
  </Box>
);

export default EmptyNotifications;
